import isEqual from 'lodash/isEqual';
import countProductResults from './countProductResults';
import getSelectionData from '../common/getSelectionData';
import fetchProducts from './fetchProducts';
import mapDataToTemplate from './mapDataToTemplate';
import productSlider from './productSlider';

/**
 * Returns a callback to load data based on filter settings.
 * The data is then mapped to templates and added to the DOM.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @return {Function} A callback function
 */
const handleLoad = (component, $itemTemplate) => async (
    e,
    filterSettings = getSelectionData(component)
) => {
    if (isEqual(filterSettings, $(component).data('lastFilterSettings'))) {
        // skip if filter settings are identical to previous settings
        return;
    }

    // set loading flag
    $(component).attr('data-loading', true);
    $(component).find('.loader').attr('data-active', true).show();

    const url = $(component).attr('data-request-url');
    const method = $(component).attr('data-request-method');
    const resultKey = $(component).attr('data-initial-result-key') || 'productListItems';
    const result = window[resultKey] || await fetchProducts(url, method, filterSettings);

    result.products.sort((a, b) => {
        const contentA = a.name.toLowerCase();
        const contentB = b.name.toLowerCase();
        if (contentA < contentB) {
            return -1;
        } else if (contentA > contentB) {
            return 1;
        }
        return 0;
    });

    const items = mapDataToTemplate(result.products, $itemTemplate);

    // update available filters
    $(component).find('.filter').trigger('filter:enable', result.availableFilterOptions);

    // update DOM
    $(component).find('.products__list').empty().append(items);
    $(component).find('.products__summary__num').text(countProductResults(result.products));
    // unset loading flag
    $(component).attr('data-loading', false);
    $(component).find('.loader').hide();
    // store latest filter settings
    $(component).data('lastFilterSettings', filterSettings);

    productSlider();

    // clear initial result
    if (window[resultKey]) window[resultKey] = null;
};

export default handleLoad;



// WEBPACK FOOTER //
// ./src/scripts/components/products/handleLoad.js